const spacing = {
  120: "30rem",
  136: "34rem",
  172: "43rem",
}

module.exports = {
  spacing,
}

exports.default = spacing
